module.exports = __webpack_public_path__ + "img/network_d.32b1e6d6.png";